import { uuidv7 } from "@ets/shared";
import { COOKIE_NAMES, TTL } from "@ets/types";
import type { CookieOptions } from "./cookie.js";
import { getPersistedValue, setPersistedValue } from "./storage.js";

const AID_COOKIE_OPTIONS: CookieOptions = {
  maxAge: TTL.ANONYMOUS_ID_SECONDS,
  sameSite: "Lax",
  secure: true,
};

/**
 * Resolve the anonymous ID:
 * 1. Read from cookie ets_aid
 * 2. Fallback to localStorage (re-persist to cookie)
 * 3. Generate new UUID v7 and persist
 */
export function resolveAnonymousId(): string {
  const existing = getPersistedValue(COOKIE_NAMES.ANONYMOUS_ID, AID_COOKIE_OPTIONS);
  if (existing) return existing;

  const newId = uuidv7();
  setPersistedValue(COOKIE_NAMES.ANONYMOUS_ID, newId, AID_COOKIE_OPTIONS);
  return newId;
}
